import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../../../layout/theme-next/provider';

export default makeStyles<NextTheme>((theme) => ({
  input: {
    resize: 'none',
  },
  inputSmall: {
    padding: theme.spacing(0.5, 1),
  },
  withEndAdornment: {
    paddingRight: 0,
  },
  withStartAdornment: {
    paddingLeft: 0,
  },
}));
